import React from 'react'
import { FormattedMessage } from 'react-intl'
import { useMarket } from 'src/hooks/useMarket'
import styles from '../styles.module.css'

export function SubscriptionSuccessMsg() {
  const { feedbackMessageType } = useMarket()

  const subtitleMessageId =
    feedbackMessageType === 'text'
      ? 'subscription.thank-you-for-being-part-of-our-community'
      : 'subscription.we-have-sent-you-an-email'

  return (
    <>
      <h5 className={styles.subscriptionBoxTitle}>
        <FormattedMessage id="global.thank-you" />
      </h5>
      <p className={styles.subscriptionBoxSubTitle}>
        <FormattedMessage id={subtitleMessageId} />
      </p>
    </>
  )
}
